import { render, staticRenderFns } from "./userBannerEl.vue?vue&type=template&id=70d5e820&scoped=true&"
import script from "./userBannerEl.vue?vue&type=script&lang=js&"
export * from "./userBannerEl.vue?vue&type=script&lang=js&"
import style0 from "./userBannerEl.vue?vue&type=style&index=0&id=70d5e820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d5e820",
  null
  
)

export default component.exports